export const FlareClipboardElementStyleWhitelist: string[] = [
  'list-style-type', // Keep so that lists can retain their style
  'page-break-after', // Keep so that madcap-page-break-schema-plugin can parse them
  'page-break-before', // Keep so that madcap-page-break-schema-plugin can parse them
  'width', // Keep so that multimedia can retain their width
  'height' // Keep so that multimedia can retain their height
];
